import { ApiProperty } from "@nestjs/swagger";
import { IsAlphanumeric, IsDateString, IsNotEmpty, IsOptional, IsString, Length, Matches, MaxLength } from "class-validator";

export class CalibrationDto {
     @ApiProperty()
     @IsNotEmpty({ message: 'Calibration Id should not be empty' })
     @IsAlphanumeric()
     @IsOptional()
     calibrationId: number;

     @ApiProperty({ description: 'Machine description' })
     @IsNotEmpty({ message: 'Machine description should not be empty' })
     @IsString()
     @Length(1, 50)
     machineDescription: string;

     @ApiProperty({ description: 'Barcode number' })
     @IsNotEmpty({ message: 'Barcode number should not be empty' })
     @IsString()
     @Length(1, 50)
     barcodeNo: string;

     @ApiProperty({ description: 'Instrument' })
     @IsNotEmpty({ message: 'Instrument should not be empty' })
     @IsString()
     @Length(1, 50)
     instrument: string;

     @ApiProperty({ description: 'Instrument make' })
     @IsNotEmpty({ message: 'Instrument make should not be empty' })
     @IsString()
     @Length(1, 50)
     instrumentMake: string;

     @ApiProperty({ description: 'Model or type' })
     @IsNotEmpty({ message: 'Model/Type should not be empty' })
     @IsString()
     @Length(1, 50)
     modelType: string;

     @ApiProperty({ description: 'Serial number' })
     @IsNotEmpty({ message: 'Serial number should not be empty' })
     @IsString()
     @Length(1, 50)
     serialNo: string;

     @ApiProperty({ description: 'Calibration range' })
     @IsNotEmpty({ message: 'Calibration range should not be empty' })
     @IsString()
     @Length(1, 50)
     calibrationRange: string;

     @ApiProperty({ description: 'Calibration due date', type: String, format: 'date' })
     @IsNotEmpty({ message: 'Calibration due date should not be empty' })
     @IsDateString()
     calibrationDueOn: Date;

     @ApiProperty({ description: 'Calibration frequency' })
     @IsNotEmpty({ message: 'Calibration frequency should not be empty' })
     @IsString()
     @Length(1, 50)
     calibrationFrequency: string;

     @ApiProperty({ description: 'Location' })
     @IsNotEmpty({ message: 'Location should not be empty' })
     @IsString()
     @Length(1, 50)
     location: string;

     @ApiProperty()
     isActive: boolean;

     createdAt: Date;

     @ApiProperty()
     @IsOptional()
     @MaxLength(40, { message: 'Created user allows maximum 40 characters' })
     @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: 'Created User should be only alphabets' })
     createdUser: string;

     updatedAt: Date;

     @ApiProperty()
     @IsOptional()
     @MaxLength(40, { message: 'Updated user allows maximum 40 characters' })
     @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: 'Updated user should be only characters' })
     updatedUser: string;

     @ApiProperty()
     versionFlag: number;
     @ApiProperty()
     plant?: string;

     @ApiProperty()
  fileName?:string;
  
  @ApiProperty()
  filePath?:string;
}